<div class="page-container">
  <div class="overlay-color">
    <div class="form-container">
      <!-- logo -->
      <div class="container-logo">
        <img class="login-logo" src="assets/logos/logo-agenda-group-7479.svg" />
      </div>

      <!--Loading Message-->
        <div *ngIf="loading" class="forgot-msg-container">
          <p class="forgot-msg-title">Redefinindo sua senha, aguarde um instante...</p>
        </div>

      <!-- form -->
      <form
        [formGroup]="fgForm"
        (ngSubmit)="onSubmit()"
        *ngIf="!loading"
        class="form-group-page"
      >

        <!--Message-->
        <div class="forgot-msg-container">
          <p class="forgot-msg-title">Acabamos de enviar um código por e-mail</p>
          <p class="forgot-msg-info">
            Insira o código de verificação de 6 dígitos enviado para seu e-mail.
          </p>
        </div>

        <!-- confirmation code -->
        <mat-form-field appearance="outline" class="form-field-password">
          <mat-label class="form-label-password">Código de 6 digitos</mat-label>
          <input
            matInput
            formControlName="code"
            type="code"
            autocomplete="code"
            readonly="false"
            class="borda"
          />
          <mat-error *ngIf="fgForm.get('code')?.hasError('required')">
            Informe o código de verificação
          </mat-error>
          <mat-error *ngIf="fgForm.get('code')?.hasError('minlength')">
            O código deve ter no mínimo 6 dígitos
          </mat-error>
        </mat-form-field>

        <!--Message-->
        <div class="forgot-msg-container">
          <p class="forgot-msg-title">Crie uma nova senha</p>
          <p class="forgot-msg-info">
            Para sua segurança crie uma senha nova com no mínimo 6 caracteres.
          </p>
        </div>

        <!-- password -->
        <mat-form-field appearance="outline" class="form-field-password">
          <mat-label class="form-label-password">Senha nova</mat-label>
          <input
            matInput
            formControlName="password"
            type="password"
            autocomplete="password"
            readonly="false"
          />
          <mat-error *ngIf="fgForm.get('password')?.hasError('minlength')">
            {{ passwordMinLengthErrorMsg }}
          </mat-error>
          <mat-error *ngIf="fgForm.get('password')?.hasError('required')">
            {{ passwordRequiredErrorMsg }}
          </mat-error>
        </mat-form-field>

        <!-- confirm password -->
        <mat-form-field appearance="outline" class="form-field-password">
          <mat-label class="form-label-password">Repetir senha nova</mat-label>
          <input
            matInput
            formControlName="confirmPassword"
            type="password"
            autocomplete="confirmPassword"
            readonly="false"
          />
          <mat-error
            *ngIf="fgForm.get('confirmPassword')?.hasError('minlength')"
          >
            {{ passwordMinLengthErrorMsg }}
          </mat-error>
          <mat-error
            *ngIf="fgForm.get('confirmPassword')?.hasError('required')"
            >{{ passwordRequiredErrorMsg }}</mat-error
          >
          <mat-error *ngIf="f.confirmPassword?.errors?.mustMatch">
            {{ passwordMatchErrorMsg }}
          </mat-error>
        </mat-form-field>

        <button mat-raised-button class="btn-confirm"
          [disabled]="fgForm.invalid || !fgForm.dirty"
        >
          <span class="btn-confirm-msg">Confirmar</span>
        </button>
      </form>

      <!-- resend code -->
      <div *ngIf="!loading" class="warn-msg-container">
        <span class="warn-msg">Não recebeu o código?</span>

        <button class="btn-resend-code" (click)="resendCode()">
          <span class="resend-code">Reenviar código</span>
        </button>
      </div>

      <mat-progress-bar
        *ngIf="loading"
        mode="indeterminate"
        class="effect-mid"
      ></mat-progress-bar>
    </div>
  </div>
</div>
